<template>
  <div class="client" v-loading="loading">
    <template v-if="slist.length">
      <!-- <div class="client_expert">
        <div class="item" v-for="(item, index) in slist" @click="buyProcurement(item.id)">
          <img v-if="sid == 9" src="../../assets/images/client/yw.png" alt="">
          <img v-if="sid == 10" src="../../assets/images/client/sx.png" alt="">
          <img v-if="sid == 11" src="../../assets/images/client/yy.png" alt="">
          <img v-if="sid == 12" src="../../assets/images/client/wl.png" alt="">
          <img v-if="sid == 13" src="../../assets/images/client/hx.png" alt="">
          <img v-if="sid == 14" src="../../assets/images/client/sw.png" alt="">
          <img v-if="sid == 15" src="../../assets/images/client/ls.png" alt="">
          <img v-if="sid == 16" src="../../assets/images/client/dl.png" alt="">
          <img v-if="sid == 17" src="../../assets/images/client/zz.png" alt="">
          <p class="text">
            <el-tooltip v-if="item.pname.length >= 14" effect="dark" :content="item.pname" placement="top-start"><span>{{item.pname}}</span></el-tooltip>
            <template v-else>
              {{item.pname}}
            </template>
          </p>
        </div>
      </div> -->
      <div class="client_expert">
        <div :class="['item', { 'yw': sid == 9 }, { 'sx': sid == 10 }, { 'yy': sid == 11 }, { 'wl': sid == 12 }, { 'hx': sid == 13 }, { 'sw': sid == 14 }, { 'ls': sid == 15 }, { 'dl': sid == 16 }, { 'zz': sid == 17 }]" v-for="(item, index) in slist" :key="index">
          <div class="name">
            <el-tooltip v-if="item.pname.length >= 30" effect="dark" :content="item.pname" placement="top-start"><p>{{ item.pname }}</p></el-tooltip>
            <template v-else>
              <p>{{ item.pname }}</p>
            </template>
          </div>
          <div class="progress">
            <el-progress :text-inside="true" color="#fff" :stroke-width="12" :percentage="((item.userLastTestInfo.havDoNum / item.userLastTestInfo.questionCount) * 100).toFixed(2)"></el-progress>
          </div>
          <div class="msg">
            <p v-if="!item.userLastTestInfo.havDoNum">尚未作答</p>
            <p v-else>已作答{{ item.userLastTestInfo.havDoNum }}题 | 完成{{ ((item.userLastTestInfo.havDoNum / item.userLastTestInfo.questionCount) * 100).toFixed(2) }}%</p>
          </div>
          <div class="button">
            <button v-if="!item.userLastTestInfo.havDo || (item.userLastTestInfo.havDo && item.userLastTestInfo.auditStatus && item.userLastTestInfo.completeStatus)" @click="buyProcurement(item.id)">开始测试</button>
            <button v-else @click="continueShowDialog(item.userLastTestInfo.testId, item.id)">继续测试</button>
            <button v-if="item.userLastTestInfo.havDo && item.userLastTestInfo.auditStatus" @click="historicalRecords(item.id)">历史结果</button>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="stotal > 16"
        style="float: right"
        layout="prev, pager, next"
        :page-size="16"
        @current-change="currentChange"
        :total="stotal">
      </el-pagination>
    </template>
    <template v-else>
      <div class="no-c">
        <img src="../../assets/images/client/no-c.png" alt="">
      </div>
    </template>

    <el-dialog
      :close-on-press-escape="true"
      center
      title="交卷"
      custom-class="battle-sham-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :visible.sync="continueDialog"
      :show-close="false"
    >
      <div class="content">
        继续测试会继续做答本卷已保存的测试，重新测试会进行一次新的测试，已保存的记录会被清空
      </div>
      <div class="button">
        <button @click="continueDialog = false">取消</button>
        <button @click="resetTesting">重新测试</button>
        <button @click="continueTesting">继续测试</button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      continueDialog: false,
      continueInfo: {
        id: 0,
        testId: 0,
      },
      sid: 9, // 学科id
      knowledgeId: 0, // 知识点Id
      pid: null, // 试卷id
      slist: [], // 数据列表
      loading: true,
      wxPay: false, // 微信支付
      wxShow: false, // 显示微信支付界面
      payCodeUrl: undefined, // 支付路径
      dialogVisible: false,
      hasActive: false,
      stotal: 0, // 总数
      activeInfo: {
        subjectList: []
      },
      paperAlltotal: 0, // 活动期间任意学科购买总数
      singleFamily: 0, //  活动期间单科购买次数
      limitSubject: 0, // 是否限制学科 0 不限学科 1 限制学科
      subjectShowPreferential: [], // 展示的学科数组
      oldUser: 0, // 查看老用户购买次数
      html: '', // 支付宝支付结构
      orderInfo: {}, // 订单信息
      userInfo: {}, // 用户信息
      isAgent: false, // 是否是代理商
      agentInfo: {},
      isVip: 0, // 是否是老vip
      params: {
        // 筛选条件
        orderBy: "3",
        rule: 1,
        subjectId: null,
        appId: 200,
        dateType: null,
        pageIndex: 1,
        pageSize: 16,
        year: null,
        pname: null,
        typeId: null
      },
      subjectList: [
        {
          id: 10,
          label: "数学",
        },
        {
          id: 9,
          label: "语文",
        },
        {
          id: 11,
          label: "英语",
        },
        {
          id: 12,
          label: "物理",
        },
        {
          id: 13,
          label: "化学",
        },
        {
          id: 14,
          label: "生物",
        },
        {
          id: 16,
          label: "地理",
        },
        {
          id: 15,
          label: "历史",
        },
        {
          id: 17,
          label: "政治",
        },
      ],
    }
  },
  methods: {
    // 历史记录
    historicalRecords (paperId) {
      this.$router.push({
        path: '/report_history',
        query: {
          paper_id: paperId,
          app_id: 400
        }
      })
    },
    // 继续测试
    continueTesting () {
      // let knowledgeId = this.$route.query.knowledge_id || null
      this.$router.push({
        path: '/continue_evaluation',
        query: {
          id: this.continueInfo.testId,
          paper_id: this.continueInfo.id,
          app_id: 400,
          // knowledge_id: knowledgeId
        }
      })
    },
    // 重新测试
    resetTesting () {
      // let knowledgeId = this.$route.query.knowledge_id || null
      this.$router.push({
        path: '/paper/paper_ts',
        query: {
          paper_id: this.continueInfo.id,
          app_id: 400
          // knowledge_id: knowledgeId
        }
      })
    },
    continueShowDialog (testId, id) {
      this.continueInfo.id = id
      this.continueInfo.testId = testId
      this.continueDialog = true
    },
    currentChange (value) {
      this.params.pageIndex = +value
      this.getSubjectList(this.params.subjectId, this.knowledgeId)
    },
    // 回去试卷列表信息
    getSubjectList (id, knowledgeId) {
      this.loading = true;
      this.params.subjectId = +id
      this.$HTTP
        .executeGet(`${this.$APIS.GET_PAPER_LIST_NAVI}/${knowledgeId}`, this)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            if (res.data != null && res.data.length) {
              this.slist = res.data != null ? res.data : [];
              this.stotal = res.data != null ? res.data.length : 0
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false;
        })
    },
    // 点击开始答题
    buyProcurement(paperId) {
      this.pid = paperId
      // let knowledgeId = this.$route.query.knowledge_id || null
      this.$router.push({
        path: '/paper/paper_ts',
        query: {
          paper_id: paperId,
          app_id: 400,
          // knowledge_id: knowledgeId
        }
      })
    }
  },
  created () {
    this.sid = this.$route.query.id
    this.knowledgeId = this.$route.query.knowledge_id
    this.getSubjectList(this.sid, this.knowledgeId)
  }
}
</script>
<style lang="scss" scoped>
.no-c {
  width: 100%;
  img {
    display: block;
    margin: 0 auto;
  }
}
.client {
  width: 1748px;
  margin: 0 auto;
}
.client_expert {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-top: 32px;
  .item {
    margin-bottom: 20px;
    width: 387px;
    height: 200px;
    position: relative;
    cursor: pointer;
    border-radius: 8px;
    .name {
      width: 100%;
      height: 90px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        // text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.35);
      }
    }
    .progress {
      width: 100%;
      padding: 0 30px;
    }
    .msg {
      line-height: 45px;
      font-size: 16px;
      color: #fff;
      text-align: center;
    }
    .button {
      display: flex;
      justify-content: space-evenly;
      button {
        width: 100px;
        height: 32px;
        border-radius: 16px;
        background: #fff;
        border: none;
        outline: none;
        font-size: 16px;
        color: #009792;
        cursor: pointer;
      }
    }
  }
  .yw {
    background: #7ddedb;
  }
  .sx {
    background: #94bdd7;
  }
  .yy {
    background: #ff7c7d;
  }
  .wl {
    background: #69b9ef;
  }
  .hx {
    background: #6ed1f1;
  }
  .sw {
    background: #8bca5c;
  }
  .ls {
    background: #dfa265;
  }
  .dl {
    background: #f1995e;
  }
  .zz {
    background: #ff7c7d;
  }
  /* 如果最后一行是3个元素 */
  .item:last-child:nth-child(4n - 1) {
      margin-right: calc(24% + 3% / 3);
  }
  /* 如果最后一行是2个元素 */
  .item:last-child:nth-child(4n - 2) {
      margin-right: calc(48% + 6% / 3);
  }
  /* 如果最后一行是1个元素 */
  .item:last-child:nth-child(4n - 3) {
      margin-right: calc(72% + 9% / 3);
  }
}
</style>
<style lang="scss" scoped>
/deep/ .pay-dialod-visible {
  width: 612px;
  height: 500px;
  background-color: #fff;
  padding: 0;
  .count {
    .wx_box_success {
      h3 {
        font-size: 30px;
        color: #585858;
        text-align: center;
      }
    }
    .wx_box {
      background-color: #fff;
      margin-top: 15px;
      h3 {
        font-size: 18px;
        color: #585858;
        text-align: center;
      }

      .price {
        text-align: center;
        font-size: 18px;
        color: #585858;
        margin-top: 20px;

        .p_num {
          font-size: 28px;
          text-decoration: line-through;
        }

        .p_num_new {
          font-size: 28px;
          color: #e50001;
        }

        
      }

    }
    .zfb_box {
      background-color: #fff;
      margin-top: 20px;
      h3 {
        font-size: 18px;
        color: #585858;
        text-align: center;
      }
    .foot-vip{
      .text-info{
        font-size : 16px;text-align:center;
      }
      .btn-container{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 20px;
        /deep/ .el-button{
          background : #1890FF;
          color:#FFF;
          margin-top:20px;
        }

        .el-button{
          background : #1890FF;
          color:#FFF;
        }
      }
    }
    }
    width: 100%;
    height: 100%;
    position: relative;
    .has_active_price {
      font-size: 28px;
      color: red;
      line-height: 58px;
      margin-left: 38px;
      width: 200px;

      .lineation {
        font-size: 16px;
        color: #a6a6a6;
      }

      .vipPreferential {
        display: block;
      }
    }
    .vip_card {
      width: 290px;
      float: right;
      height: auto;
      margin-right: 10px;
      margin-top: 10px;
      cursor: pointer;
    }
    .right_c {
      width: 100%;
      height: 300px;
      float: right;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .wx {
        width: 190px;
        float: left;
        height:60px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        cursor: pointer;
      }

      .wx:hover{
        box-shadow: 10px 10px 10px #ddd;
      }

      .zfb {
        width: 190px;
        height:60px;
        float: right;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .zfb:hover {
        box-shadow: 10px 10px 10px #ddd;
      }
    }
  }
}
/deep/ .has_active {
  .new_user {
    margin-left: 38px;
    border: 1px solid #ff6672;
    background: #ffdede;
    display: inline-block;
    border-radius: 6px;
    padding: 7px 14px;
    font-size: 16px;
  }

  .new_user_name {
    margin-left: 38px;
    margin-top: 14px;
    font-size: 16px;
    color: #a6a6a6;
  }
  .pay_type {
    margin-top: 53px;
    margin-left: 38px;
    font-size: 20px;
    color: #585858;
  }
  .has_active_price {
    font-size: 28px;
    color: red;
    line-height: 58px;
    margin-left: 38px;
    width: 200px;

    .lineation {
      font-size: 16px;
    }
  }

  .vip_card {
    width: 290px;
    float: right;
    height: auto;
    margin-right: 10px;
    margin-top: 10px;
    cursor: pointer;
  }
  .tips_d {
    margin-left: 38px;
    margin-top: 14px;
    font-size: 16px;
    color: #a6a6a6;
  }

  .right_d {
    width: 100%;
    float: right;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 20px;

    .wx {
      margin-top: 26px;
      padding: 6px 18px;
      width: 190px;
      float: left;
      height: 60px;
      position: relative;
      border-radius: 6px;
      background-color: #fff;
      border: 1px solid #a6a6a6;
      img {
        width: 100%;
        height: 100%;
      }
      cursor: pointer;
    }

    .wx:hover{
      box-shadow: 10px 10px 10px #ddd;
    }

    .zfb {
      margin-top: 26px;
      padding: 6px 18px;
      border-radius: 6px;
      width: 190px;
      height: 60px;
      float: right;
      cursor: pointer;
      border: 1px solid #a6a6a6;
      background-color: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .zfb:hover {
      box-shadow: 10px 10px 10px #ddd;
    }
  }
}
.pay_types {
  margin-top: 53px;
  margin-left: 38px;
  font-size: 20px;
  color: #585858;
  text-align: left;
}
.right_f {
  width: 100%;
  float: right;
  background-color: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .wx {
    margin-top: 26px;
    padding: 6px 18px;
    width: 190px;
    float: left;
    height: 60px;
    position: relative;
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #a6a6a6;
    img {
      width: 100%;
      height: 100%;
    }
    cursor: pointer;
  }

  .wx:hover{
    box-shadow: 10px 10px 10px #ddd;
  }

  .zfb {
    margin-top: 26px;
    padding: 6px 18px;
    border-radius: 6px;
    width: 190px;
    height: 60px;
    float: right;
    cursor: pointer;
    border: 1px solid #a6a6a6;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .zfb:hover {
    box-shadow: 10px 10px 10px #ddd;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .battle-sham-dialog {
  width: 800px;
  height: auto;

  .el-dialog__header {
    padding: 0;
    height: 50px;
    width: 100%;
    background: #3db0f0;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      line-height: 50px;
    }
  }
  .el-dialog__body {
    .content {
      font-size: 18px;
      line-height: 46px;
      color: #3c3c3c;
      text-indent: 2em;
      padding: 0 70px;
    }

    .button {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      margin-top: 60px;
      button {
        width: 100px;
        height: 35px;
        background: #3db0f0;
        font-size: 16px;
        color: #fff;
        border-radius: 4px;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
}
</style>